import Header from "../Components/Header";
import "../Styles/Homepage.css";
import image1 from "../Assets/image1.jpg";
import image2 from "../Assets/image2.jpg";
import Contact from "../Components/Contact";
import logo1 from "../Assets/logoart1.jpg";
import logo2 from "../Assets/logoart2.jpg";
import logo3 from "../Assets/logoart3.jpg";
import logo4 from "../Assets/logoart4.jpg";
import logo5 from "../Assets/logoart5.jpg";
import logo6 from "../Assets/logoart6.jpg";
import logo7 from "../Assets/logoart7.jpg";
import CaseStudies from "../Components/CaseStudies";

const Homepage = () => {
  const logoImages = [logo1, logo2, logo3];
  const logoImages2 = [logo4, logo6, logo5, logo7];

  return (
    <div>
      <Header />
      <section id="heroSection">
        <div className="left-section" style={{ alignItems: "center" }}>
          <h1
            style={{ fontWeight: "400", fontFamily: "Playfair Display, serif" }}
          >
            Crafting <br />
            <span
              style={{
                color: "white",
                fontWeight: "bold",
              }}
            >
              Unique Brands
            </span>{" "}
            <br />
            Engaging Your Audience
          </h1>
          <p>
            Now is the perfect moment to establish your brand or business. With
            thousands of brands launching daily, standing out is crucial.
            Partnering with a skilled brand designer simplifies connecting with
            your ideal audience.
          </p>
          <button
            onClick={() => {
              window.location.href = "#contact";
            }}
          >
            Message Me
          </button>
        </div>
        <div className="right-section">
          <img
            src={image2}
            alt="Designer Workspace"
            style={{ width: "100%", objectFit: "cover" }}
          />
        </div>
      </section>
      <section id="about">
        <div className="right-section">
          <img
            src={image1}
            alt="Designer Workspace"
            style={{ width: "100%", objectFit: "cover" }}
          />
        </div>
        <div
          className="left-section"
          style={{
            alignItems: "left",
            backgroundColor: "#f5f5f5",
          }}
        >
          <h1
            style={{
              fontWeight: "400",
              color: "black",
            }}
          >
            Heyy! I'm{" "}
            <span
              style={{
                fontWeight: "600",
              }}
            >
              Disena
            </span>
          </h1>
          <p style={{ color: "black" }}>
            My love for graphic design sparked during my teenage years, a career
            I always aspired to but never imagined achievable. Now, here I am. I
            specialize in Logo and Brand Identity, collaborating with incredible
            clients from across the globe. That’s what drives me—partnering with
            kindred spirits, creating inspiring brands, and fostering lasting
            connections.
          </p>
        </div>
      </section>
      <section id="logos">
        <div
          className="logo-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(120px, 1fr))",

            width: "100%",
            margin: " auto",
          }}
        >
          {logoImages.length === 0 ? (
            <p
              style={{
                gridColumn: "1/-1",
                textAlign: "center",
                fontSize: "1.2rem",
              }}
            >
              Logo showcase coming soon!
            </p>
          ) : (
            logoImages.map((img, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#fff",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  aspectRatio: "1 / 1",
                  overflow: "hidden",
                  width: "100%",
                }}
                className="logo-container"
              >
                <img
                  src={img}
                  alt={`Logo ${idx + 1}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            ))
          )}
        </div>
        <div
          className="logo-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(120px, 1fr))",
            width: "100%",
            margin: " auto",
          }}
        >
          {logoImages2.length === 0 ? (
            <p
              style={{
                gridColumn: "1/-1",
                textAlign: "center",
                fontSize: "1.2rem",
              }}
            >
              Logo showcase coming soon!
            </p>
          ) : (
            logoImages2.map((img, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#fff",

                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  aspectRatio: "1 / 1",
                  overflow: "hidden",
                  width: "100%",
                }}
                className="logo-container"
              >
                <img
                  src={img}
                  alt={`Logo ${idx + 1}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            ))
          )}
        </div>
      </section>
      <section
        id="case-studies"
        style={{ width: "100%", backgroundColor: "#f2f2f2" }}
      >
        <CaseStudies />
      </section>
      <section id="contact">
        <Contact id="contact" />
      </section>
    </div>
  );
};

export default Homepage;
